// import 'izitoast/dist/css/iziToast.min.css'
// import iZtoast from 'izitoast'
import store from '../store'
import {_error,_success,_info,_warning} from '../toast'
import { AppConfiguration } from "read-appsettings-json";

export function _handleError(err) {
    store.dispatch('CHANGE_LOADER',false);
    let errorResult=({data:{success:false}});
    if (!err.status && !err.response) {
        _error("Bağlantı hatası",'Network');
        return errorResult;
    }
    const { status } = err.response;
    const error = err.response.data;
    if (status === 400) {
        _error(error.Message,error.Title);
        return errorResult;
    }
    if(status === 401){
        store.dispatch('REMOVE_TOKEN');
        location.reload();
    }
    if (status === 403) {
        _error(error.Message,error.Title);
        return errorResult;
    }
  }
 export function _handleSuccess(response) {
     store.dispatch('CHANGE_LOADER',false);
     if(response.data.message)
      _success(response.data.message);

    return ({ data: response.data });
  }
  export function _getUrl()
  {
    store.dispatch('CHANGE_LOADER',true);
   return  AppConfiguration.Setting().baseURL ; //'https://localhost:44310/api'
    //    return process.env.API_URL  //'https://mdtcloudapi.azurewebsites.net/api'
  }
  export function _getInvoiceProcessUrl()
  {
    store.dispatch('CHANGE_LOADER',true);
   return  AppConfiguration.Setting().InvoiceProcessURL ; //'https://localhost:44310/api'
    //    return process.env.API_URL  //'https://mdtcloudapi.azurewebsites.net/api'
  }
  export function _getEprocessUrl()
  {
    store.dispatch('CHANGE_LOADER',true);
   return  AppConfiguration.Setting().baseURLforEprocess ; 
  }
//   const toast = {
//     error: (message, title = 'Hata') => {
//         return iZtoast.error({
//             title: title,
//             message: message,
//             position: 'bottomRight'
//         });
//     },
//     success: (message, title = 'Başarılı') => {
//         return iZtoast.success({
//             title: title,
//             message: message,
//             position: 'bottomRight'
//         });
//     },
//     info: (message, title = 'Bilgi') => {
//         return iZtoast.info({
//             title: title,
//             message: message,
//             position: 'bottomRight'
//         });
//     },
//     warning: (message, title = 'Uyarı') => {
//         return iZtoast.warning({
//             title: title,
//             message: message,
//             position: 'bottomRight'
//         });
//     }
// };

